export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6821.fe073b2e.jpg";